export default __webpack_public_path__ + "static/media/Designer.1cb16fbd.png";